import {
    Component,
    OnInit,
    AfterViewInit,
  } from '@angular/core';
  import {ApiService} from '../../shared/services/api.service';
  import {ActivatedRoute} from '@angular/router';
  import {InternalService} from '../../shared/services/internal.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
  
  
  @Component({
    selector: 'app-dataSafetyPolicy',
    templateUrl: 'dataSafetyPolicy.component.html',
    styleUrls: ['dataSafetyPolicy.component.css'],
  })
  export class DataSafetyPolicyComponent implements OnInit {

    deleteAccountQues: [];
    phoneNumber: string;
    status: number;
    message: string;
  
    constructor(
      public apiService: ApiService,
      public internalService: InternalService,
      public translate: TranslateService,
      public toastr: ToastrService,
      private route: ActivatedRoute,) {
  
    }
  
    ngOnInit() {
      this.deleteAccountRequest();
    }

    deleteAccountRequest() {
      this.apiService.getDeleteAccountQuestions().subscribe((res: any) => {
        console.log('-*/',res)
        this.deleteAccountQues = res.res;
        
      })
    }

    sendReq() {
      if (!this.phoneNumber || !this.status ) {
        this.translate.get('PleaseFillAllRequiredFiled').subscribe(res=>{
          this.toastr.error(res);
        })
        return false;
      }

      this.phoneNumber = this.phoneNumber.replace(/\s/g, "");
      this.phoneNumber = this.phoneNumber.replace("+", "");
  
      const body = {
        PhoneNumber: this.phoneNumber,
        Description: this.message,
        DeleteAccountQuestinId: Number(this.status)
      };
      // console.log(body)
  
      this.apiService.sendDeleteAccountReq(body).subscribe((res: any) => {
        // console.log(res);
        if(res.stu===1){
          this.translate.get('DeleteAccountReqMessage').subscribe(response =>{
            this.toastr.success(response);
          })
        }
      });
    }
  
  }
  